import { BaseService } from "./base.service";
import { IBidCommitteeStatus } from "models/BidCommittee/BidCommitteeStatusModel";

class BidCommitteeStatusServiceInternal extends BaseService {
	getBidCommitteeStatusList = async (): Promise<IBidCommitteeStatus[]> =>
		this.callApi<IBidCommitteeStatus[]>(
			`BidCommitteeStatus/GetBidCommitteeStatusList`,
			"GET",
			undefined,
			undefined,
			undefined,
			undefined,
			true
		);
}

export const BidCommitteeStatusService =
	new BidCommitteeStatusServiceInternal();
